<template>
  <div class="pricing mt-8">
    <v-container>
      <v-row class="justify-center">
        <h1><span>15</span> Day Money Back Guarantee On All Plans</h1>
      </v-row>
      <v-row>
      <v-col cols="12">
          <v-card class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">
                Pro
              </h5>
              <h6 class="card-price text-center">
                <span class="currency">$ </span>25<span class="period">
                  /month</span
                >
                <span class="and-price">Billed Annually</span>
              </h6>
              <v-divider class="my-4" />
              <ul class="fa-ul">
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Users - 3
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Warehouses - 1
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Barcodes
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Items - 2000
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  CSV/PDF Reporting
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Alerts
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Custom Fields - 10
                </li>
              </ul>
              <v-btn class="trybtn btn-main" to="/subscription/business">
                Try Now
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">
                Business
              </h5>
              <h6 class="card-price text-center">
                <span class="currency">$ </span>47.4<span class="period">
                  /month</span
                >
                <span class="and-price">Billed Annually</span>
              </h6>
              <v-divider class="my-4" />
              <ul class="fa-ul">
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Users - 5
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Warehouses - 1
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Barcodes
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Items - 3000
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  CSV/PDF Reporting
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Alerts
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Custom Fields - 20
                </li>
              </ul>
              <v-btn class="trybtn btn-main" to="/subscription/business">
                Try Now
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">
                Company
              </h5>
              <h6 class="card-price text-center">
                <span class="currency">$ </span>177<span class="period">
                  /month</span
                >
                <span class="and-price">Billed Annually</span>
              </h6>
              <v-divider class="my-4" />
              <ul class="fa-ul">
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Users - 10
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Warehouses - 5
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Items - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Custom barcode labels - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Advanced Reporting
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  10 Integrations
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Custom Fields - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Alerts
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  5 HOURS setup assistance
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Backup - 3 months
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  User access rights
                </li>
              </ul>
              <v-btn class="trybtn btn-main" to="/subscription/company">
                Try Now
              </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">
                Corporate
              </h5>
              <h6 class="card-price text-center">
                <span class="currency">$ </span>7500<span class="period">
                  /year</span
                >
                <span class="and-price">Billed Annually</span>
              </h6>
              <v-divider class="my-4" />
              <ul class="fa-ul">
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Users - 30
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Warehouses - unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Items - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Custom Advanced Reporting
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Integrations - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Alerts - Custom
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Phone/Email/Chat Support - Unlimited
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Setup assistance - 20 hours
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Backup - 6 months
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  User access rights
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  API access for Integrations
                </li>
                <li class="d-flex no-wrap align-center">
                  <span class="mr-2">
                    <v-img
                      src="@/assets/icons/svg/check-bold-black.svg"
                      style="width: 16px !important; height: 16px !important"
                    ></v-img>
                  </span>
                  Single Sign On
                </li>
              </ul>
              <v-btn class="trybtn btn-main" to="/subscription/corporate">
                Try Now
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PricingMobile'
}
</script>

<style scoped lang="scss">
p,
li {
  font-size: 18px;
  font-weight: 500;
  font-family: sans-serif;
  color: #383838;
  line-height: 1.8;
  margin-bottom: 15px;
}

a {
  color: #7671bd;
  outline: 0;
}

a:focus,
a:hover,
a:active {
  outline: 0;
  color: #7671bd;
  text-decoration: none;
}

::selection {
  color: #fff;
  background: #7671bd;
  text-shadow: none;
}

::-webkit-selection {
  color: #fff;
  background: #7671bd;
  text-shadow: none;
}

::-moz-selection {
  color: #fff;
  background: #7671bd;
  text-shadow: none;
}

:active,
:focus {
  outline: none;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/* pricing */
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
.pricing {
  min-height: 100vh;
  padding-top: 40px;
  background-color: #f5f5f5;
}
.pricing-logo {
  text-align: center;
}
.pricing .pricing-logo img {
  max-width: 140px;
}

.pricing-header {
  background: #e8eaff;
}
.pricing h1 {
  font-weight: 500;
  text-align: center;
  margin-bottom: 1.2em;
  font-size: 22px;
  padding: 0 20px;
  line-height: 2rem;
  color: #3e3d52;
  font-family: sans-serif;
}

.pricing h1 span {
  color: #6c61c5;
  font-family: sans-serif;
}

.pricing-table {
  margin: 60px 0 60px;
}

.pricing .card-body {
  background-color: #fff;
  position: relative;
  min-height: 600px;
  padding-bottom: 40px;
}

.pricing .card {
  border: none;
  border-radius: 1rem;
  transition: all 0.2s;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.pricing .card h6 {
  font-weight: 600;
  font-family: sans-serif;
  min-height: 86px;
  line-height: 1.4;
}

.pricing .fa-ul {
  list-style-type: none;
  margin-left: 3em;
  padding-left: 0;
}

.pricing .card-title {
  margin: 0.2em 0;
  font-size: 1.8em;
  letter-spacing: 0.1rem;
  font-weight: bold;
  background: #787780;
  padding: 10px 0;
  color: #fff;
  font-family: sans-serif;
}

.pricing .card-price {
  font-size: 36px;
  margin: 0;
}

.pricing .card-price .currency {
  font-size: 24px;
  font-weight: 500;
}
.pricing .card-price .period {
  font-size: 18px;
  font-weight: 400;
}

.pricing .card-price .and-price {
  font-size: 18px;
  display: block;
  font-weight: 500;
  color: #b5b5b5;
}

.pricing ul li {
  margin-bottom: 0;
  font-size: 16px;
}

.trybtn {
  font-size: 1.25em;
  letter-spacing: 0.1rem;
  font-weight: 700;
  padding: 10px;
  transition: all 0.2s;
  width: 240px;
  max-width: 100%;
  color: white;
  margin: 0 auto;
  border-color: #7671bd;
  background-color: #7671bd !important;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  &hover {
    border-color: #514d89;
    background-color: #514d89;
  }
}

/* -------------------------------------*/
.prev:hover::after,
.next:hover::after {
  width: 40px;
}
</style>
